/* eslint-disable no-console */
export interface IParselyTracking {
  url: string;
  urlRef: string;
}

/**
 * Parse.ly Track page view
 * @param {string} url URL to be tracked
 * @param {string} urlRef Referring URL
 */
export const dynamicParselyTrackPageView = (data: IParselyTracking) => {
  const { url, urlRef } = data;
  console.info(`url:${url}`);
  console.info(`urlRef:${urlRef}`);
  // @ts-ignore
  if (window.PARSELY && window.PARSELY.beacon) {
    console.info(`parse.ly: track page view url:${data.url} urlRef:${data.urlRef} `);
    // @ts-ignore
    window.PARSELY.beacon.trackPageView({
      url,
      urlRef,
      js: 1,
    });
  } else {
    console.info('parse.ly not initialized - 1. ensure that config/skysport.it was loaded');
  }
};
